export default "__VITE_ASSET__De6uw6bb__"